export default "__VITE_ASSET__BVx4XVMp__"